export default __webpack_public_path__ + "static/media/Avatar-15-noback.b5e4d6fe.png";